import { NavLink } from "react-router-dom";

export type HubSubNavItem = {
  to: string;
  label: string;
  gfOnly?: boolean;
};

// Stammdaten sind Teil der Administration > Daten. Der direkte Home-Button
// bleibt oben links; daher gibt es keine fachliche Hauptreiterleiste mehr.
export const HUB_SUBNAV: HubSubNavItem[] = [];

type Props = {
  items: HubSubNavItem[];
  isGf: boolean;
};

export function HubSubNav({ items, isGf }: Props) {
  const visibleItems = items.filter((item) => !item.gfOnly || isGf);
  if (visibleItems.length === 0) return null;
  return (
    <nav className="hub-subnav" aria-label="Hub-Bereiche">
      {visibleItems.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === "/home"}
          className={({ isActive }) =>
            `hub-subnav-item ${isActive ? "is-active" : ""}`
          }
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
